<template>

    <!-- компонент таблицы -->
    <tablecustom 
        :dataParams="dataParams"
        :objParams="objParams"
        @search="searchB" 
        :columns="columns" 
        :rows="rows" 
        :pages="objPages"
        :showpag="true"
        @getdata="getdata"
        @changelimit="changelimit"
        @open="open"
    />

    <!-- создание услуги -->
    <!-- <created 
        v-if="showModalAdd" 
        @close="showModalAdd = false"
        :number="number"
    ></created> -->

    <!-- карточка точки -->
    <!-- <viewcard  
        v-if="showModal == true" 
        @close="showModal = false" 
        :objcard="objcard"
        @remove="remove"
        @toEdit="toEdit"
    /> -->

    <viewTask 
        v-if="showTask"
        @close="showTask = false"
        :shortapplic="objcard"
    />

    <viewPresent 
        v-if="showPresent"
        @close="showPresent = false"
        :shortapplic="objcard"
    />

    <viewTickets 
        v-if="showTicket"
        @close="showTicket = false"
        :obj="objcard"
    />

</template>

<script>
import tablecustom from '@/components/globaltable/index';
import viewTask from '@/views/tasks/view/viewtask'
import viewPresent from '@/views/presentations/view/index'
import viewTickets from '@/views/newtickets/view/index'
// import created from '@/views/services/createservice'
// import viewcard from '@/views/services/view'
// import infoblocks from '@/components/info/blocks'
import { Clients, Presentations, Tasks, Tickets } from '@/API'
import { storeS } from '@/store';
import { mutateTypeHistoryAcc } from '@/usabilityScripts/globalMutate.js'

let apiServe = new Clients();
let apiPresentations = new Presentations();
let apiTasks = new Tasks();
let apiTickets = new Tickets();

export default {
    props: ['number', 'company'],
    components: { 
        tablecustom, 
        viewTickets,
        viewTask,
        viewPresent
        // infoblocks,
        // viewcard,
        // created
    },
    data() {
        return {
            form: {},
            showTask: false,
            showPresent: false,
            showTicket: false,
            showModal: false,
            showModalAdd: false,
            infoblockShow: false,
            objcard: '',
            objPages: "",
            dataParams: {
                status: false,
                page: "services"
            },
            objParams:{
                page: '1',
                pagelimit: '10',
                search: '',
                company: ''
            },
            rows: [],
            columns: [
                {
                    name: 'ID',
                    text: "id",
                    align: "left",
                    width: 300,
                    status: true,
                },
                {
                    name: this.$t("type"),
                    text: "type",
                    align: "left",
                    width: 200,
                    status: true,
                    mutate: (item) => this.mutateType(item).name,
                    mutateClass: (item) => this.mutateType(item).color
                },
                {
                    name: this.$t("createDate"),
                    text: "createDatetime",
                    align: "right",
                    width: 200,
                    status: true,
                },
                {
                    name: this.$t("closeDatetime"),
                    text: "closeDatetime",
                    align: "right",
                    width: 200,
                    status: true,
                    mutate: (item) => item == null ? '-' : item,
                },
            ],
            information: [
                {
                    title: this.$t('Total'),
                    value: "0",
                    icon: "las la-file-invoice",
                    color: "info"
                },
                {
                    title: this.$t('successfully'),
                    value: "0",
                    icon: "las la-file-invoice",
                    color: "success"
                },
                {
                    title: this.$t('notSuccessful'),
                    value: "0",
                    icon: "las la-file-invoice",
                    color: "danger"
                },
            ]
        }
    },
    created(){
        this.getdata()
    },
    methods: {
        getdata(page){
            this.objParams.company = this.company
            this.objParams.page = page != undefined ? page : '1';
            apiServe.getAccountHistory(this.number,this.objParams).then(result => {
                if(result.status == 'done') {
                    this.rows = result.data.items
                    this.objPages = result.data;
                } else {
                    this.$toast.error(this.$t('error'));
                }
            })
        },
        open: function(e){
            switch(e.type){
                case "task":
                    apiTasks.getTask(e.id).then(result => {
                        if(result.status == 'done'){
                            this.objcard = result.data;
                            this.showTask = true;
                        }
                    })
                break;
                case "presentation":
                    apiPresentations.getCard(e.id).then(result => {
                        if(result.status == 'done'){
                            this.objcard = result.data;
                            this.showPresent = true;
                        }
                    })
                break;
                case "ticket":
                    apiTickets.getTicket(e.id).then(result => {
                        if(result.status == 'done'){
                            this.objcard = result.data;
                            this.$emit('openTicket', this.objcard)
                        }
                    })
                break;
            }
            // apiServe.getCardService(e.nomenclatureId).then(result => {
            //     if(result.status == 'done') {
            //         this.objcard = result.data
            //         this.showModal = true
            //     }
            // })
        },
        searchB(e){
            this.objParams.search = e
            this.getdata()
        },
        changelimit: function(limit){
            this.objParams.pagelimit = limit;
            this.getdata();
        },
        mutateType(e){
            return mutateTypeHistoryAcc(e)
        },
    },
    mounted(){
        
    },
    computed: {
        checks(){
            return storeS.checks
        },
        perms(){
            return storeS.perms
        }
    }
}
</script>